<div class="jw-modal">
    <div class="jw-modal-header">
        <span class="dialog-title">{{headerText}}</span>
        <button class="modal-close-button" type="button" tabindex="-1" (click)="close()" [hidden]="!showCloseButton">
            <span class="pi pi-times" style="padding:4px;"></span>
        </button>
    </div>
    <div class="jw-modal-body">
        <ng-content></ng-content>
    </div>
    <!-- <div class="jw-modal-footer" hidden="true">
        <button (click)="close()">Close</button>
    </div> -->
</div>
<div class="jw-modal-background"></div>